export enum ScreenSize {
  Base = 'base',
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
  Xl = 'xl',
  TwoXl = '2xl',
}
